import { motion } from 'framer-motion';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'María González',
      role: 'Propietaria',
      text: 'Excelente servicio. Vaciaron el piso de mi madre en un día y dejaron todo impecable. Muy profesionales y respetuosos con las zonas comunes.',
      rating: 5,
      type: 'text',
    },
    {
      name: 'Carlos Martínez',
      role: 'Administrador de fincas',
      text: 'Trabajo con ellos habitualmente para vaciados de pisos en herencias. Siempre cumplen los plazos y coordinan perfectamente con la portería.',
      rating: 5,
      type: 'text',
    },
    {
      name: 'Laura Sánchez',
      role: 'Agente inmobiliaria',
      image: 'https://public.readdy.ai/ai/img_res/814e6532d731b6efec9ddf3cea1fb717.jpg',
      text: 'Servicio impecable',
      rating: 5,
      type: 'image',
    },
    {
      name: 'Javier Ruiz',
      role: 'Particular',
      text: 'Necesitaba vaciar un local comercial urgentemente y lo hicieron en 48 horas. Precio justo y trabajo muy bien hecho. Los recomiendo totalmente.',
      rating: 5,
      type: 'text',
    },
    {
      name: 'Ana Torres',
      role: 'Heredera',
      image: 'https://readdy.ai/api/search-image?query=Satisfied%20woman%20client%20in%20bright%20empty%20apartment%20after%20house%20clearance%20Barcelona&width=800&height=600&seq=testimonial-img-004&orientation=landscape',
      text: 'Muy discretos y eficientes',
      rating: 5,
      type: 'image',
    },
  ];

  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-white text-navy text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4">
            Testimonios
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-5 max-w-2xl mx-auto">
            Lo que dicen nuestros clientes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`rounded-2xl overflow-hidden ${
                testimonial.type === 'image'
                  ? 'relative h-80 lg:h-96'
                  : 'bg-white p-8 border border-gray-200'
              }`}
            >
              {testimonial.type === 'text' ? (
                <>
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-12 h-12 rounded-full bg-orange-bg flex items-center justify-center text-orange font-bold text-lg">
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <h4 className="font-bold text-navy">{testimonial.name}</h4>
                      <p className="text-sm text-gray-600">{testimonial.role}</p>
                    </div>
                  </div>
                  <i className="ri-double-quotes-l text-3xl text-orange-bg mb-4 block"></i>
                  <p className="text-gray-700 leading-relaxed mb-4">{testimonial.text}</p>
                  <div className="flex gap-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-orange"></i>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name} - ${testimonial.role}`}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/40 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                    <h4 className="text-lg font-bold mb-1">{testimonial.name}</h4>
                    <p className="text-sm text-white/80 mb-3">{testimonial.role}</p>
                    <p className="text-sm mb-3">{testimonial.text}</p>
                    <div className="flex gap-1">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-white"></i>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
